import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import useApi from './Utilities/useAPI';
import DocumentViewer from './Utilities/DocumentViewer';

const ProfileContext = createContext();

export const ProfilesProvider = ({ children }) => {

  // Get the objectId from localStorage
  const objectId = localStorage.getItem("objectId");

  const { callApiFunction } = useApi();

  // Check if objectId is not null and not an empty string after trimming
  if (objectId !== null && objectId.trim() !== "") {
    // console.log("objectId is present:", objectId);
  } else {
    // console.log("objectId is not present or is empty."); // If objectId is not present or is an empty string after trimming
  }

  // ------------- State and functions for Projects -----------------------
  const [projectList, setprojectList] = useState([]);
  const [projectDetails, setProjectDetails] = useState({
    id: '',
    projectName: '',
    projectDescription: '',
    startMonth: '',
    startYear: '',
    endMonth: '',
    endYear: '',
    currentlyWorking: false,
    attachments: [],
  });
  const [editProjectIndex, setEditProjectIndex] = useState(null);

  const [addSection, setAddSection] = useState({
    professionalProject: false,
    professionalService: false,
    professionalAwards: false,
    professionalRecommendation: false,
  });
  const updateProjectDetails = (updatedDetails) => {
    setProjectDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const updateAttachments = (newAttachment) => {
    setProjectDetails((prevState) => ({
      ...prevState,
      attachments: [...prevState.attachments, newAttachment],
    }));
  };

  const handleSaveForProject = () => {
    if (editProjectIndex !== null) {
      // Edit existing project
      const updatedProjectList = projectList.map((project, index) =>
        index === editProjectIndex ? projectDetails : project
      );
      setprojectList(updatedProjectList);
      setEditProjectIndex(null);
    } else {
      // Add new project
      setprojectList([...projectList, projectDetails]);
    }
    resetProjectDetails();
  };

  const resetProjectDetails = () => {
    setProjectDetails({
      id: '',
      projectName: '',
      projectDescription: '',
      startMonth: '',
      startYear: '',
      endMonth: '',
      endYear: '',
      currentlyWorking: false,
      attachments: [],
    });
  };

  // ------------------- State and Functions for Awards -----------------------------------
  const [awardsList, setAwardsList] = useState([]);
  const [awardEditIndex, setAwardEditIndex] = useState(true);

  const [awardDetails, setAwardDetails] = useState({
    awardTitle: '',
    associatedWith: '',
    awardIssuer: '',
    issueMonth: '',
    issueYear: '',
    awardDescription: '',
    awardAttachments: [],
  });

  const updateAwardsAttachments = (newAttachment) => {
    setAwardDetails((prevState) => ({
      ...prevState,
      awardAttachments: [...prevState.awardAttachments, newAttachment],
    }));
  };
  // --------------------- States and Functions for Services ----------------------------
  const [services, setServices] = useState({
    id: '',
    yourservices: [],
    servicesDetails: '',
    workLocation: '',
    remote: '',
    dayStart: '',
    dayEnd: '',
    workStart: '',
    workEnd: '',
    currency: '',
    hourRate: '',
    serviceAttachments: [],
    removedAttachments: []
  });

  const handleServiceAdd = (newService) => {
    setServices((prevState) => ({
      ...prevState,
      yourservices: [...prevState.yourservices, newService],
    }));
  };

  const handleInputChangeServices = (e) => {
    const { name, value } = e.target;
    setServices((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const updateServicesAttachments = (newAttachment) => {
    const attachmentWithId = { ...newAttachment, id: uuidv4() };
    setServices((prevState) => ({
      ...prevState,
      serviceAttachments: [...prevState.serviceAttachments, attachmentWithId],
    }));
  };

  const removeServiceAttachments = (id) => {
    // console.log('Entered removeServiceAttachments to delete id', id, services?.serviceAttachments);
    setServices((prevState) => ({
      ...prevState,
      serviceAttachments: prevState.serviceAttachments.map((attachment) =>
        attachment?.id === id ? { ...attachment, toBeDeleted: true } : attachment
      ),
    }));
  };

  const resetServices = () => {
    setServices({
      id: '',
      yourservices: [],
      servicesDetails: '',
      workLocation: '',
      remote: '',
      dayStart: '',
      dayEnd: '',
      workStart: '',
      workEnd: '',
      currency: '',
      hourRate: 0,
      serviceAttachments: [],
      removedAttachments: []
    })
  }

  // ------------------- Visibility States and Functions ------------------------
  const [visibilityStates, setVisibilityStates] = useState({
    projects: true,
    awards: true,
    // Add other sections here
  });

  const handleVisibilitySwitch = (section) => {
    setVisibilityStates((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const setSectionVisibility = (section, isVisible) => {
    setVisibilityStates((prevState) => ({
      ...prevState,
      [section]: isVisible,
    }));
  };


  const [educationList, setEducationList] = useState([]);
  const [certificateList, setcertificateList] = useState([]);
  const [ExperienceList, setExperienceList] = useState([])

  // Functions to get the most recent education and experience entries
  const getMostRecentEducation = () => {
    if (educationList.length === 0) return { instlogo: { name: '', type: '', data: '' }, institute: '' };
    const { instlogo, institute } = educationList[0];
    return { instlogo, institute };
  };

  const getMostRecentExperience = () => {
    if (ExperienceList.length === 0) return { companylogo: { name: '', type: '', data: '' }, companyName: '' };
    const { companylogo, companyName } = ExperienceList[0];
    return { companylogo, companyName };
  };

  const [ProfessionalDetails, setProfessionalDetails] = useState({
    userRefId: '',
    Aboutme: '',
    profilePic: '',
    coverPic: '',
    companyLogo: '',
    Designation: '',
    Department: '',
    CompanyName: '',
    CompanyWeb: '',
    CompanyEmail: '',
    CompanyAddress: '',
    CompanyPhone: '',
    StartDate: '',
    EndDate: '',
    isCurrentlyWorking: '',
    isVerified: {
      CompanyEmail: false,
      CompanyPhone: false
    },
    isFieldVisible: {
      companyName: true,
      companyWebsite: true,
      designation: true,
      department: true,
      professionalEmail: false,
      phoneNumber: false,
      companyAddress: true,
    },
    isSectionPublic: {
      Aboutme: true,
      skills: true,
      profLanguages: true,
      services: true,
      softSkills: true,
      profSkills: true,
      profTools: true
    },
    skills: [],
    profLanguages: [],
    softSkills: [],
    profSkills: [],
    profTools: []
  });

  // Resume ---------------------------------------------------------

  const [Resume, setResume] = useState({
    files: [],
    videos: []
  });

  const updateResume = (arrayName, fileObject, actionType = 'replace') => {
    setResume((prevState) => {
      switch (actionType) {
        case 'add':
          return {
            ...prevState,
            [arrayName]: [...prevState[arrayName], fileObject],
          };
        case 'remove':
          return {
            ...prevState,
            [arrayName]: prevState[arrayName].filter(file => file.id !== fileObject.id),
          };
        case 'replace':
          return {
            ...prevState,
            [arrayName]: fileObject, // Assuming fileObject here is the new array of files
          };
        default:
          return prevState;
      }
    });
  };

  // Personal Profile------------------------------------------------------------------------------------------

  const [PersonalDetails, setPersonalDetails] = useState({
    userRefId: '',
    aboutme: '',
    profilePic: '',
    coverPic: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    nickName: '',
    personalEmail: '',
    phoneNumber: '',
    gender: '',
    maritalStatus: '',
    personAddress: '',
    isFieldPublic: {
      firstName: true,
      lastName: true,
      dateOfBirth: true,
      nickName: true,
      personalEmail: true,
      phoneNumber: true,
      gender: true,
      maritalStatus: true,
      personAddress: true,
    },
    hobbies: [],
    personalLanguages: [],
    isSectionPublic: {
      hobbies: true,
      aboutme: true,
      languages: true
    },
    allergy: [],
    medicCondition: [],
    blood: '',
    medicHistory: [],
    medicAttachments: [],
    removedAttachments: [],
    isHealthPublic: true,
    fatherDet: { id: null, fName: '', lName: '', dob: '', blood: '', email: '', phoneNo: '', isVerified: false },
    motherDet: { id: null, fName: '', lName: '', dob: '', blood: '', email: '', phoneNo: '', isVerified: false },
    spouseDet: { id: null, fName: '', lName: '', dob: '', blood: '', email: '', phoneNo: '', isVerified: false },
    kids: [
      { id: null, fName: '', lName: '', dob: '', blood: '' },
    ],
    isFamilyPublic: true,
    connectionCount: 0
  });

  const updateMedicalAttachments = (newAttachment) => {
    setPersonalDetails((prevState) => ({
      ...prevState,
      medicAttachments: [...prevState.medicAttachments, newAttachment],
    }));
  };

  const removeMedicalAttachment = (index) => {
    setPersonalDetails((prevState) => {
      const removed = prevState.medicAttachments[index];
      const updatedAttachments = prevState.medicAttachments.filter((_, i) => i !== index);

      return {
        ...prevState,
        medicAttachments: updatedAttachments,
        removedAttachments: [...prevState.removedAttachments, removed],
      };
    });
  };

  // --------------------------- Document Viewer ----------------------------------
  const [openViewer, setOpenViewer] = useState(false);
  const [fileView, setFileView] = useState(null);

  // Open Document Viewer
  const openDocumentViewer = (file) => {
    setFileView(file);
    setOpenViewer(true);
  };

  // Close Document Viewer
  const closeDocumentViewer = () => {
    setOpenViewer(false);
    setFileView(null);
  };

  // Connections ------------------------------------------------------------------
  const [connectionCount, setConnectionCount] = useState(0);
  const [connectionList, setConnectionList] = useState([])

  // Passing Coampny ID
  const [companyId, setCompanyId] = useState(() => {
    // Retrieve companyId from localStorage if available
    const storedCompanyId = localStorage.getItem('companyId');
    return storedCompanyId ? JSON.parse(storedCompanyId) : null;
  });

  useEffect(() => {
    if (companyId !== null) {
      localStorage.setItem('companyId', JSON.stringify(companyId));
    }
  }, [companyId]);


  // ----------------------------- Completion Status -------------------------------
  const [personalProfileCompletion, setPersonalProfileCompletion] = useState(0);
  const [professionalProfileCompletion, setProfessionalProfileCompletion] = useState(0);

  const getCompletionStatus = async () => {
    try {
      const response = await callApiFunction("profileCompletionStatus");
      const data = response.data;
      if (response.status === "SUCCESS") {
        setPersonalProfileCompletion(data.personal_profile_completion);
        setProfessionalProfileCompletion(data.professional_profile_completion);
      } else {
        console.log("Failed to fetch Completion Status", response);
      }
    } catch (error) {
      console.log("GET Completion Status Failed", error);
    }
  };

  // const getCompletionStatus = useCallback(async () => {
  //   try {
  //     const response = await callApiFunction('profileCompletionStatus');
  //     const data = response.data;
  //     if (response.status === 'SUCCESS') {
  //       setPersonalProfileCompletion(data.personal_profile_completion);
  //       setProfessionalProfileCompletion(data.professional_profile_completion);
  //     } else {
  //       console.log("Failed to fetch Completion Status", response);
  //     }
  //   } catch (error) {
  //     console.log("GET Completion Status Failed", error);
  //   }
  // }, [callApiFunction]);

  // useEffect(() => {
  //   getCompletionStatus();
  // }, []);

  return (
    <ProfileContext.Provider value={{
      PersonalDetails, setPersonalDetails, updateMedicalAttachments, removeMedicalAttachment, ExperienceList, setExperienceList, Resume, setResume, updateResume,
      ProfessionalDetails, setProfessionalDetails, educationList, setEducationList, certificateList, setcertificateList, services, setServices, handleServiceAdd,
      handleInputChangeServices, updateServicesAttachments, removeServiceAttachments, resetServices, projectDetails, setProjectDetails, projectList, setprojectList, updateAttachments, updateProjectDetails,
      editProjectIndex, setEditProjectIndex, handleSaveForProject, resetProjectDetails, awardsList, setAwardsList, awardEditIndex, setAwardEditIndex,
      updateAwardsAttachments, getMostRecentEducation, getMostRecentExperience, handleVisibilitySwitch, setSectionVisibility, personalProfileCompletion, setPersonalProfileCompletion,
      professionalProfileCompletion, setProfessionalProfileCompletion, getCompletionStatus, openDocumentViewer, closeDocumentViewer, connectionCount, setConnectionCount,
      connectionList, setConnectionList, companyId, setCompanyId, setAddSection, addSection
    }}>
      {children}
      {fileView && (
        <DocumentViewer
          open={openViewer}
          onClose={closeDocumentViewer}
          file={fileView}
        />
      )}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => useContext(ProfileContext);
